export class ApiResponse<D = any> {
  public statusCode: number;
  public data: D;

  constructor({ data, statusCode }: ApiResponse) {
    this.statusCode = statusCode;
    this.data = data;
  }
}
